export default __webpack_public_path__ + "static/media/placeholder_store04-nl-mobile.600d49ce.png";